import { render, staticRenderFns } from "./WebcamCapture.vue?vue&type=template&id=3b3a5313&scoped=true"
import script from "./WebcamCapture.vue?vue&type=script&lang=js"
export * from "./WebcamCapture.vue?vue&type=script&lang=js"
import style0 from "./WebcamCapture.vue?vue&type=style&index=0&id=3b3a5313&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3a5313",
  null
  
)

export default component.exports